import { Injectable } from '@angular/core';
import { MediaHavenPlugin } from '../entities/mediahaven-plugins.entity';
import { PluginGuard } from './plugin.guard';

@Injectable({
    providedIn: 'root'
})
export class GenerativeMetadataGuard extends PluginGuard {
    protected PLUGINS_TO_CHECK: MediaHavenPlugin[] = [
        MediaHavenPlugin.GENERATIVE_METADATA_OPEN_AI,
        MediaHavenPlugin.GENERATIVE_METADATA_MISTRAL_AI
    ];
}
